module.exports = __webpack_public_path__ + "img/moren.139fb1ef.png";